<template>
  <div class="helper-panel">
    <f7-toolbar tabbar top no-shadow no-hairline>
      <f7-link tab-link="#tab-words" tab-link-active>
        <img src="../static/books_emoji.png" width="23" alt="emoji" />
      </f7-link>
      <f7-link tab-link="#tab-topics">
        <img src="../static/open-book_emoji.png" width="23" alt="emoji" />
      </f7-link>
      <f7-link tab-link="#tab-quick-phrases">
        <img src="../static/memo_emoji.png" width="21" alt="emoji" />
      </f7-link>
      <f7-link tab-link="#tab-questions">
        <img src="../static/electric-light-emoji.png" width="21" alt="emoji" />
      </f7-link>
    </f7-toolbar>

    <f7-tabs>
      <f7-tab id="tab-words" class="page-content " tab-active>
        <f7-list class="no-margin-vertical" no-hairlines no-chevron>
          <f7-list-item
            title="Category"
            smart-select
            :smart-select-params="{
              openIn: 'popup',
              searchbar: true,
              cssClass: 'smart-select-popup',
              searchbarPlaceholder: 'Search Category',
              closeOnSelect: true
            }"
          >
            <select name="Category" @change="handleChangeCategory">
              <option
                v-for="(category, index) in categories"
                :key="category.id"
                :value="category.id"
              >
                {{ category.name }}
              </option>
            </select>
          </f7-list-item>
        </f7-list>

        <f7-searchbar
          no-hairline
          custom-search
          :disable-button="false"
          :clear-button="false"
          :value="searchQuery"
          @searchbar:search="({ query }) => (searchQuery = query)"
          @keydown.enter.native.exact.prevent
          @keyup.enter.native.exact="startSearch"
          @keydown.enter.shift.native.exact
        >
          <f7-link
            slot="input-wrap-end"
            class="search-button"
            icon-f7="search"
            @click="startSearch"
          ></f7-link>
        </f7-searchbar>

        <f7-list
          v-if="!Object.keys(customeSearch).length && words.length && !loadingData"
          accordion-list
          virtual-list
          inset
          no-hairlines
          no-hairlines-between
          :virtual-list-params="{ items: words, height: 34 }"
        >
          <f7-list-item
            v-for="word in words"
            :key="word.id"
            accordion-item
            :title="word.name"
            @accordion:beforeopen="handleGetDescription(word.name)"
          >
            <f7-button
              v-if="currentLessonId"
              slot="root-end"
              fill
              round
              class="add-to-chat-button"
              @click="setWordToChatHandler(word.id)"
            >
              <f7-icon f7="info"></f7-icon>
            </f7-button>

            <f7-button
              v-if="currentLessonId"
              slot="root-end"
              fill
              class="add-to-chat-button"
              @click="setQuestionByWordToChatHandler(word.id)"
            >
              <f7-icon f7="help"></f7-icon>
            </f7-button>
            <f7-accordion-content>
              <f7-block v-if="word.description && word.description.definition">
                <p v-if="word.description.pronunciation">
                  <span>Pronunciation:</span>
                  {{ `${word.description.pronunciation}` }}
                </p>

                <p v-if="word.description.definition">
                  <span>Definition:</span>
                  {{ `${word.description.definition}.` }}
                </p>

                <p v-if="word.description.synonyms.length">
                  <span>Synonyms:</span>
                  <f7-badge
                    v-for="(synonym, index) in word.description.synonyms"
                    :key="index"
                    color="blue"
                  >
                    {{ synonym }}
                  </f7-badge>
                </p>
              </f7-block>

              <f7-block v-else class="margin-vertical">
                <f7-preloader v-if="wordDescriptionLoading"></f7-preloader>
                <p v-else>Nothing found for this word.</p>
              </f7-block>
            </f7-accordion-content>
          </f7-list-item>
        </f7-list>

        <div v-else-if="Object.keys(customeSearch).length && !loadingData" class="card">
          <div class="card-header">{{ customeSearch.word }}</div>
          <div class="card-content card-content-padding">
            <p>
              <span>Pronunciation:</span>
              {{ `${customeSearch.pronunciation}` }}
            </p>
            <p>
              <span>Definition:</span>
              {{ `${customeSearch.definition}.` }}
            </p>
          </div>
          <div class="card-footer">
            <span>Synonyms:</span>
            <f7-badge
              v-for="(synonym, index) in customeSearch.synonyms"
              :key="index"
              color="blue"
              >{{ synonym }}</f7-badge
            >
          </div>
        </div>

        <f7-block v-else class="helper-panel-preloader">
          <f7-preloader v-if="loadingData"></f7-preloader>
          <span v-if="!loadingData && !Object.keys(customeSearch).length && !words.length"
            >Select a topic or start a search by words.</span
          >
        </f7-block>
      </f7-tab>

      <f7-tab id="tab-topics" class="page-content topic" @tab:show="getTopicHandler">
        <f7-searchbar
          v-if="topics.length"
          no-hairline
          search-container=".gramar-list"
          search-in=".item-title"
          :disable-button="false"
        >
        </f7-searchbar>

        <f7-list
          v-if="topics.length"
          class="gramar-list topic-list wrap-list"
          accordion-list
          inset
          no-hairlines
          no-hairlines-between
        >
          <f7-list-item v-for="topic in topics" :key="topic.id" accordion-item :title="topic.title">
            <span slot="header">
              {{ getTopicCategoriesCrumbs(topic.categoryId) }}
            </span>
            <f7-accordion-content>
              <f7-block
                v-for="(content, index) in topic.contents"
                :key="index"
                :text-color="
                  content.type === 'текст' || content.type === 'текст с переводом' ? 'black' : ''
                "
                :class="{ 'topic_block-video': content.type === 'аудио' }"
                :inset="content.type === 'аудио'"
              >
                <p v-if="content.type === 'текст'" v-html="content.text"></p>

                <div
                  v-if="content.type === 'текст с переводом'"
                  class="translated-text"
                  v-html="content.text"
                ></div>

                <ul v-if="content.type === 'аудио'" class="voice-list">
                  <li v-for="(item, index2) in content.audio" :key="index2">
                    {{ item.text }}
                  </li>
                </ul>
              </f7-block>
            </f7-accordion-content>
          </f7-list-item>
        </f7-list>
      </f7-tab>

      <f7-tab id="tab-quick-phrases" class="page-content">
        <f7-searchbar
          no-hairline
          search-container=".quick-phrases-list"
          search-in=".item-title"
          :disable-button="false"
        >
        </f7-searchbar>

        <f7-list
          class="quick-phrases-list wrap-list"
          accordion-list
          inset
          no-hairlines
          no-hairlines-between
        >
          <f7-list-item
            v-for="(phrase, index) in quickPhrases"
            :key="phrase.id"
            :title="`${index + 1}. ${phrase.text}`"
          >
          </f7-list-item>
        </f7-list>
      </f7-tab>

      <f7-tab id="tab-questions" class="page-content" @tab:show="questionsTabHandler">
        <!-- <f7-block
          v-if="!questionsLoad"
          class="helper-panel-preloader margin-vertical"
        >
          <f7-preloader></f7-preloader>
        </f7-block> -->

        <f7-searchbar
          v-if="questionsLoad && questions.length"
          no-hairline
          search-container=".questions-list"
          search-in=".item-title"
          :disable-button="false"
        >
        </f7-searchbar>

        <f7-block
          v-if="questionsLoad && !questions.length"
          class="helper-panel-preloader margin-vertical"
        >
          <span v-if="questionsLoad && !questions.length">
            Not Found
          </span>
        </f7-block>

        <f7-list
          v-else
          class="questions-list wrap-list topic-list"
          accordion-list
          inset
          no-hairlines
          no-hairlines-between
        >
          <f7-list-item
            v-for="question in questions"
            :key="question.id"
            accordion-item
            :title="question.name"
            @accordion:beforeopen="handleGetQuestionDetail(question.id)"
          >
            <span slot="header">
              {{ question.word_categories[0].name }}
            </span>
            <f7-button
              v-if="currentLessonId"
              slot="root-end"
              fill
              class="add-to-chat-button"
              @click="addToChat(question.id)"
            >
              <f7-icon f7="help"></f7-icon>
            </f7-button>
            <f7-accordion-content>
              <f7-block v-if="question.details && !questionDetailLoad" class="no-padding-left">
                <p v-if="question.details.body" class="padding-left">
                  {{ question.details.body }}
                </p>

                <f7-list>
                  <f7-list-item v-for="(answer, index2) in question.details.answers" :key="index2">
                    <div v-html="answer.text"></div>
                    <f7-icon
                      slot="media"
                      :f7="answer.correct ? 'check_round_fill' : 'close_round_fill'"
                      :color="answer.correct ? 'green' : 'red'"
                    ></f7-icon>
                  </f7-list-item>
                </f7-list>
              </f7-block>

              <f7-block v-else class="margin-vertical">
                <f7-preloader v-if="questionDetailLoad"></f7-preloader>
                <p v-else>Not Found</p>
              </f7-block>
            </f7-accordion-content>
          </f7-list-item>
        </f7-list>
      </f7-tab>
    </f7-tabs>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import apiRequest from '@/js/helpers/apiRequest.js';
import notify from '@/js/helpers/notify.js';

export default {
  name: 'HelperPanel',

  data() {
    return {
      searchQuery: '',
      customeSearch: {},
      loadingData: false,
      currentCategory: null
    };
  },

  computed: {
    words() {
      const currentList = this.wordsByCategory.find(
        category => category.categoryId === this.currentCategory
      );

      if (currentList && currentList.words) {
        if (this.searchQuery) {
          return currentList.words.filter(
            word => word.name.toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1
          );
        } else {
          return currentList.words;
        }
      } else {
        return [];
      }
    },

    ...mapState({
      categories: state => state.helper.categories,
      wordsByCategory: state => state.helper.wordsByCategory,
      quickPhrases: state => state.helper.quickPhrases,
      wordDescriptionLoading: state => state.helper.wordDescriptionLoading,
      topics: state => state.helper.topics,
      topicCategories: state => state.helper.topicCategories,
      questions: state => state.helper.questions,
      questionsLoad: state => state.helper.questionsLoad,
      questionDetailLoad: state => state.helper.questionDetailLoad,
      currentLessonId: state => state.lesson.currentLessonId
    })
  },

  methods: {
    async handleChangeCategory(e) {
      this.searchQuery = '';
      this.customeSearch = {};
      this.currentCategory = e.target.value;

      try {
        this.loadingData = true;
        await this.getWordsByCategory({ id: e.target.value });
        this.loadingData = false;
      } catch (error) {
        this.loadingData = false;
      }
    },

    async handleGetDescription(word) {
      try {
        await this.getWordDescription({
          word,
          categoryId: this.currentCategory
        });
      } catch (error) {
        this.store.commit('SET_LOADING_DESCRIPTION', false);

        if (error.customeError) {
          notify({ text: error.customeError });
        } else {
          notify({ text: 'Something went wrong 🤯. Please try again.' });
        }
      }
    },

    async startSearch() {
      try {
        this.loadingData = true;
        const body = new FormData();
        body.append('word', this.searchQuery);

        const res = await apiRequest(`word`, 'POST', body, true);

        this.loadingData = false;

        if (res.error) {
          notify({ text: res.error });
          return;
        }

        if (res.success && res.success.results) {
          const {
            pronunciation: { all: pronunciation }
          } = res.success;
          const { definition, synonyms } = res.success.results[0];

          this.customeSearch = {
            word: this.searchQuery,
            pronunciation,
            definition,
            synonyms
          };
        }
      } catch (error) {
        this.loadingData = false;
        notify({ text: 'Something went wrong 🤯. Please try again.' });
      }
    },

    async questionsTabHandler() {
      try {
        await this.getQuestions();
      } catch (error) {
        if (error.customeError) {
          notify({ text: error.customeError });
        } else {
          notify({ text: 'Something went wrong 🤯. Please try again.' });
        }
      }
    },

    async handleGetQuestionDetail(id) {
      try {
        await this.getQuestionsDetail({ id });
      } catch (error) {
        if (error.customeError) {
          notify({ text: error.customeError });
        } else {
          notify({ text: 'Something went wrong 🤯. Please try again.' });
        }
      }
    },

    addToChat(questionId) {
      this.setQuestionToChat({ questionId });
    },

    async setWordToChatHandler(wordId) {
      try {
        await this.setWordToChat({ wordId });
      } catch (error) {
        if (error.customeError) {
          notify({ text: error.customeError });
        } else {
          notify({ text: 'Something went wrong 🤯. Please try again.' });
        }
      }
    },

    async setQuestionByWordToChatHandler(wordId) {
      try {
        await this.setWordToChat({ wordId });
      } catch (error) {
        if (error.customeError) {
          notify({ text: error.customeError });
        } else {
          notify({ text: 'Something went wrong 🤯. Please try again.' });
        }
      }
    },

    async getTopicHandler() {
      await this.getTopics();
    },

    getTopicCategoriesCrumbs(topicId) {
      const result = [];
      let searchId = topicId;
      let parrent = this.topicCategories.find(category => category.id === searchId);

      while (parrent !== undefined) {
        result.push(parrent.name);
        searchId = parrent.parentId;
        parrent = this.topicCategories.find(category => category.id === searchId);
      }

      return result.reverse().join(' - ');
    },

    ...mapActions({
      getWordsByCategory: 'helper/getWordsByCategory',
      getWordDescription: 'helper/getWordDescription',
      getQuestions: 'helper/getQuestions',
      getQuestionsDetail: 'helper/getQuestionsDetail',
      setQuestionToChat: 'helper/setQuestionToChat',
      setQuestionByWordToChat: 'helper/setQuestionByWordToChat',
      setWordToChat: 'helper/setWordToChat',
      getTopics: 'helper/getTopics'
    })
  }
};
</script>

<style lang="scss">
.helper-panel {
  z-index: 2;
  width: 400px;
  height: calc(100% - var(--f7-navbar-height));
  border-left: 1px solid #d8d8d8;
  box-sizing: border-box;
  align-self: flex-end;

  --f7-card-margin-horizontal: 15px;
  --f7-card-margin-vertical: 20px;
  --f7-card-box-shadow: 0;

  @media (max-width: 1440px) {
    width: 300px;
  }

  .tab-link {
    transition: all 0.25s ease;

    &:hover {
      &::after {
        background-color: #d8d8d8;
      }
    }

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: transparent;
    }
  }

  .tab-link-active {
    &:hover {
      &::after {
        background-color: #ff386b;
      }
    }

    &::after {
      background-color: #ff6189;
    }
  }

  .tabs {
    margin-top: 15px;
    /* margin-top: 0; */
    height: 100%;

    .tab.page-content {
      padding-bottom: 100px;
    }
  }

  .smart-select {
    --f7-list-item-after-font-size: 15px;
    --f7-list-item-after-text-color: #3d5170;

    &:hover {
      background-color: transparent !important;

      .item-after {
        border: 1px solid darken(#d8d8d8, 20%);
      }
    }

    &.active-state {
      background-color: transparent;
    }

    .item-title {
      flex-shrink: 0;
    }

    .item-after {
      max-width: none;
      min-height: 18px;
      width: 100%;
      flex-shrink: 1;
      border: 1px solid #d8d8d8;
      margin-left: 20px;
      padding: 7px 15px;
      border-radius: 34px;
    }
  }

  .searchbar {
    --f7-searchbar-bg-color: transparent;
    --f7-searchbar-inner-padding-right: 15px;
    --f7-searchbar-inner-padding-left: 15px;
    --f7-searchbar-input-height: 34px;
    --f7-searchbar-input-padding-horizontal: 15px;
    --f7-searchbar-input-font-size: 15px;
    --f7-searchbar-input-text-color: #3d5170;

    .searchbar-input-wrap {
      border: 1px solid #d8d8d8;
      border-radius: 34px;
    }

    .input-clear-button {
      right: 6px;
    }

    input[type='search'] {
      border-radius: 34px !important;

      &::placeholder {
        color: #3d5170;
        font-size: 15px;
      }
    }
  }

  .list.accordion-list {
    /* border: 1px solid #d8d8d8; */
    --f7-list-item-min-height: 34px;
  }

  .accordion-item-content {
    p {
      font-size: 16px;

      span {
        font-weight: 500;
        font-size: 16px;
      }

      .badge {
        &:not(:last-of-type) {
          margin-right: 5px;
        }
      }
    }
  }

  .card {
    margin-top: 20px;
    border: 1px solid #d8d8d8;

    .card-content {
      p {
        font-size: 16px;

        span {
          font-weight: 500;
          font-size: 16px;
        }
      }
    }

    .card-footer {
      flex-wrap: wrap;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;

      span:not(.badge) {
        color: #000000;
        font-weight: 500;
        font-size: 16px;
        margin-right: 10px;
      }
    }

    .badge {
      margin-bottom: 5px;

      &:not(:last-of-type) {
        margin-right: 5px;
      }
    }
  }

  .add-to-chat-button {
    position: absolute;
    top: 2.49px;
    right: 3px;
    transform: translateY(-50%);
    border-radius: 50% !important;
    display: flex;
    align-items: center;
    padding: 0;
    width: 28px;
    box-shadow: 0 4px 8px 0 rgba(255, 97, 137, 0.3);

    + .add-to-chat-button {
      right: 40px;
    }
  }
}

.search-button.link {
  position: absolute;
  top: 50%;
  right: 9px;
  transform: translateY(-50%);
  z-index: 31;
}

.searchbar-icon {
  display: none;
}

.helper-panel-preloader {
  position: absolute;
  top: calc(50% - 75px);
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;

  span {
    font-size: 16px;
    color: #87919c;
    user-select: none;
    cursor: default;
  }
}

.smart-select-popup {
  --f7-popup-tablet-width: 400px;
  --f7-popup-tablet-height: 550px;
  --f7-navbar-height: 45px;
}

.topic {
  .voice-list {
    background-color: transparent;
  }
}

.translated-text {
  display: inline-block;
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0 !important;
    background-color: #fce1b6;
    padding: 2px 3px;
    font-size: 17px;
    font-weight: 400;
    color: #000000;
    display: inline-block;
    border-bottom: 1px solid #f5a623;
  }

  > div {
    &:not(:last-of-type) {
      margin-bottom: 20px;
    }

    > div {
      &:not(:last-of-type) {
        margin-bottom: 20px;
      }
    }
  }

  p:empty {
    display: none;
  }

  br {
    display: none;
  }
}

.tenses,
.topic {
  .block {
    padding: 15px !important;
    h3 {
      margin-top: 0;
      margin-bottom: 10px;
      font-weight: 500;
      font-size: 21px;
      color: #000000;
      letter-spacing: 0;
      display: flex;
      align-items: center;
      line-height: 1;
      justify-content: space-between;

      .button {
        --f7-button-height: auto;
        padding: 5px;

        img {
          width: 24px;
        }
      }
    }

    h4 {
      margin: 25px 0 12px 0;
      font-weight: 500;
      font-size: 17px;
      color: #000000;
      letter-spacing: -0.41px;
    }

    /* mark {
      background-color: #fce1b6;
      padding: 2px 3px;
      border-bottom: 1px solid #f5a623;
    } */
  }

  &_block-video {
    --f7-block-inset-border-radius: 20px;
    padding: 20px;
    background-color: #f5f6f8;
    --f7-button-height: auto;

    ul {
      margin: 0;
      padding: 0;
      list-style: none;
    }

    li {
      position: relative;
      display: flex;
      justify-content: space-between;
      font-size: 17px;
      color: #000000;
      letter-spacing: -0.36px;

      &:not(:last-of-type) {
        margin-bottom: 18px;
      }
    }

    .button {
      /* position: absolute; */
      margin-left: 15px;
      top: 0px;
      right: 0px;
      padding: 1px;
    }
  }
}

.topic-list {
  --f7-list-item-header-font-size: 11px;
  --f7-list-item-header-text-color: #87919c;
}
</style>
